<template>
    <div>
        <breadCrumb
            :icon="'fa-chart-line'"
            :category="$t(`sideNav.navSalonReport`)"
            :subCategory="$t(`subMenu.salon_report_sales`)"
            :subSubCategory="''">
        </breadCrumb>
        <!-- <ul class="nav nav-tabs nav-tabs-clean px-3 px-sm-5 mt-3" role="tablist">
            <li class="nav-item" v-for="t in $i18n.messages[$i18n.locale].tab.reportSalesTabs" :key="t.id">
                <a class="nav-link bg-transparent fs-lg fw-400" :class="{'active': selectedTab == t.id}" @click="selectedTab = t.id">{{t.text}}</a>
            </li>
        </ul> -->
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr border-bottom-0 pt-3 d-block">
                    <salesFilter
                        ref="salesFilter"
                        :tab="selectedTab"
                        :commissionSalesItem="commissionItems"
                        @filterSalesCommission="filterSalesCommission"
                        @openStaffPositionPopup="openStaffPositionPopup"
                        @openProductPopup="openProductPopup">
                    </salesFilter>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div class="tab-content mt-2">
                            <salesItem
                                ref="salesItem"
                                :commissionSalesItem="commissionItems"
                                @setExportData="setExportData"
                                @showEditCommission="showEditCommission">
                            </salesItem>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{ 'show': isModalShow }" class="modal fade">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content modal-content-loading border-0 ">
                    <div class="modal-body text-center">
                        <div class="spinner-border text-light" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                        <div class="text-light mt-2">{{ $t('message.data.fetching_wait') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <staffPopup ref="staffPopup" @modalClose="modalClose"></staffPopup>
        <productPopup ref="productPopup" @modalClose="modalClose"></productPopup>

        <div v-if="modalShow" class="modal show">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.edit') + $t('subMenu.salon_report_order')}}
                            <small class="m-0 text-muted"><span class="text-capitalize">{{$t('salon_report.item_types.' + editData.type)}}: </span>{{editData.title}}</small>
                        </h5>
                        <button type="button" class="close" @click="modalShow = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body modal-body-lg">
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.receipt_number')}}: </div>
                            <div class="col-10 fw-300">{{editData.receiptID}}</div>
                        </div>
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.order_number')}}: </div>
                            <div class="col-10 fw-300">{{editData.orderID}}</div>
                        </div>
                        <div class="row text-primary mb-2">
                            <div class="col-2 fw-500">{{$t('label.amount')}}: </div>
                            <div class="col-10 fw-500">{{parseFloat(editData.price).toFixed(2)}}</div>
                        </div>
                        <h6 class="pt-2 text-secondary fw-500"><i class="fas fa-store mr-2"></i>{{editData.outlet}}</h6>
                        <div class="dataTables_wrapper dt-bootstrap4">
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <table class="table table-sm table-hover table-bordered table-striped w-100 dataTable dtr-inline" role="grid">
                                        <thead class="thead-themed">
                                            <tr>
                                                <th v-for="tblHeader in editFields" :key="tblHeader.key" :style="setTableHeaderStyle(tblHeader.key)">{{tblHeader.label}}</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(staff, index) in editData.staffs" :key="index">
                                            <commissionItemEdit ref="commissionItemEdit" :price="editData.price" :index="index" :staffsList="staffsList" :staff="staff"></commissionItemEdit>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="text-left border-top pt-3 mt-3 mb-3">
                                <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed" @click="submitEditCommission">{{$t('button_link.save')}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import _ from 'lodash';
import SalesFilter from './Sales_Filter'
import SalesItem from './Sales_Item'
import SalesDate from './Sales_Date'
import BreadCrumb from './../../../Bread_Crumb'
import box from './../../../../../assets/js/dashboard/salonReport/salonReport'
import { formatPrice, insertLeadingZero } from './../../../../../assets/js/dashboard/utilities'
import { handleSessionExpired, setSummaryBoxLabel, getOutletName } from './../../../../../assets/js/dashboard/dashboard'
import StaffPopup from './StaffPopup'
import ProductPopup from './ProductPopup'
import CommissionItemEdit from './../../../salonReport/commission/Commission_ItemEdit'
export default {
    name: "reportSales",
    components: {
        SalesFilter,
        SalesItem,
        BreadCrumb,
        StaffPopup,
        ProductPopup,
        CommissionItemEdit,
    },
    data() {
        return {
            salesReportSummaryBox: [],
            selectedTab: "date",
            isModalShow: false,
            commissionItems: [],
            showSummaryBox: true,
            currentFilter: {},

            modalShow: false,
            editData: {},
            staffsList: [],
        }
    },
    watch: {
        selectedTab(value) {
            // this.$refs.salesFilter.setExportData(this.commissionItems, value);
            this.filterSalesCommission(this.currentFilter)
        },
        "$i18n.locale"(val) {
            this.setSummaryBoxLabel()
        }
    },
    methods: {
        setExportData(result) {
            if (result) {
                this.$refs.salesFilter.setExportData(result, this.selectedTab);
            }
        },

        async filterSalesCommission(filter) {
            this.currentFilter = filter

            this.isModalShow = true;

            let url = `https://mall.tunai.io/report/TheNailEdge/sales?start=${this.currentFilter.startDate.format('DD/MM/YYYY')}&end=${this.currentFilter.endDate.format('DD/MM/YYYY')}`
            if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
                url = `http://localhost:5001/report/TheNailEdge/sales?start=${this.currentFilter.startDate.format('DD/MM/YYYY')}&end=${this.currentFilter.endDate.format('DD/MM/YYYY')}`
            }

            if (this.currentFilter.outlet && this.currentFilter.outlet !== 'all') {
                url += '&outletID=' + this.currentFilter.outlet
            }

            if (this.currentFilter.itemType && this.currentFilter.itemType !== 'all') {
                url += '&type=' + this.currentFilter.itemType
            }

            if (this.currentFilter.staff && this.currentFilter.staff !== 'all') {
                url += '&staff=' + this.currentFilter.staff
            }

            this.$axios({
                method: 'get',
                url: url,
                headers: { token: this.$util.getSessionToken() }
            })
                .then((response) => {
                    this.isModalShow = false;

                    var results = response.data;
                    this.$refs.salesItem.updateTable(results, this.currentFilter);
                })
                .catch((err) => {
                    this.isModalShow = false;

                    var errData = err.response.data;
                    if (errData.error == this.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        openStaffPositionPopup() {
            this.$refs.staffPopup.open()
        },
        openProductPopup() {
            this.$refs.productPopup.open()
        },
        modalClose() {
            this.filterSalesCommission(this.currentFilter)
        },

        setTableHeaderStyle(id){
            var style = {}
            switch(id){
                case "title":
                    style = {'width': '35%'};
                    break;
                // case "outlet":
                //     style = {'width': '20%'};
                //     break;
                case "editStaff":
                    style = {'width': '30%'};
                    break;
            }
            return style
        },
        showEditCommission(type, completedID, title, orderID, receiptID, outletID, price, staffs) {
            price = typeof price == 'string' ?  parseFloat(price.replace(",", "")) : price
            var staffList = [];
            console.log(staffs)
            for(var i=0; i<4; i++){
                if(i<staffs.length){
                    staffList.push(staffs[i])
                }else{
                    staffList.push({
                        staffID: 'no',
                        name: 'No Staff',
                        effort: 0,
                        pctg: 0,
                        pctg2: 0,
                        fee: 0
                    })      
                }
            }
            var data = {
                type: type,
                completedID: completedID,
                title: title,
                orderID: insertLeadingZero(orderID),
                receiptID: insertLeadingZero(receiptID),
                outletID: outletID,
                outlet: this.getOutletName(outletID),
                price: price,
                staffs: staffList
            }

            this.modalShow = true
            this.editData = data
            this.getStaffItems(data.outletID)
        },
        getStaffItems(outletID){
            var staff = [{ staffID: 'no',
                name: 'No Staff',
                effort: 0,
                pctg: 0,
                pctg2: 0,
                fee: 0
            }];
            let $vm = this
            let url = this.$api.OUTLET + "/" + outletID + this.$api.STAFF
            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                $vm.staffsList = response.data.staff;
                $vm.staffsList.push(...staff);
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        submitEditCommission(){
            var arrData = [];
            let $vm = this
            if(this.modalShow){
                for(var i=0; i<this.$refs.commissionItemEdit.length; i++){
                    var staff = this.$refs.commissionItemEdit[i].submitStaffItems();
                    if(staff.staffID != "no"){
                        arrData.push(staff)
                    }
                }
                const url =  this.$api.REPORT_COMPLETED + "/" + this.editData.completedID + this.$api.UPDATE;
                this.$axios({
                    method: 'post', 
                    url: url,
                    baseURL: this.$axios.defaults.baseURL, 
                    headers: {token: this.$util.getSessionToken()},
                    data: {staffs: arrData}
                })
                .then((response) => {
                    if(response.status == 200){
                        var retData = response.data.result[0];
                        var message = retData.item.title + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                        $vm.$parent.$parent.setModal($vm, false, true, message);
                    }
                })
                .catch((err) => {
                    var errData = err.response.data;
                    if(errData.error == $vm.$api.INVALID_TOKEN){
                        handleSessionExpired();   
                    }else{
                        var message = errData.message;
                        $vm.$parent.$parent.setModal($vm, true, true, message);
                    }
                })
            }
        },
        getOutletName(id){
            var outlets = JSON.parse(this.$store.state.outlets);
            var outletName = "";
            for(var i=0; i<outlets.length; i++){
                if(outlets[i].id == id){
                    outletName = outlets[i].text;
                    break;
                } 
            }
            return outletName;
        },
    },
    mounted() {
        let $vm = this;
        var data = {
            startDate: moment().startOf('month'),
            endDate: moment().endOf('month'),
            outlet: "all",
            search: "",
            type: "",
            itemType: "all",
            category: "all",
            folderID: "all"
        }

        $vm.filterSalesCommission(data)
    }
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}

.modal-content-loading {
    background: transparent;
    box-shadow: none;
}

.show {
    display: block;
}
</style>